import { Routes } from '@angular/router';

export const PAYMENT_ROUTES: Routes = [
  {
    path: '',
    children: [
      {
        path: 'success',
        loadComponent: () =>
          import('./pages/payment-success/payment-success.component').then(
            (x) => x.PaymentSuccessComponent
          ),
      },
      {
        path: 'error',
        loadComponent: () =>
          import('./pages/payment-error/payment-error.component').then(
            (x) => x.PaymentErrorComponent
          ),
      },
    ],
  },
  {
    path: '',
    redirectTo: 'success',
  },
];
